export const operatorsRating = [
  {
    name: "Олена R.",
    avgCheck: "730₴",
    upsell: "95%",
    leads: 55,
    salary: "5 200₴",
    combo: 18,
  },
  {
    name: "Ігор M.",
    avgCheck: "710₴",
    upsell: "90%",
    leads: 59,
    salary: "5 200₴",
    combo: 14,
  },
  {
    name: "Ви",
    avgCheck: "650₴",
    upsell: "88%",
    leads: 51,
    salary: "5 200₴",
    combo: 11,
  },
  {
    name: "Світлана K.",
    avgCheck: "625₴",
    upsell: "85%",
    leads: 45,
    salary: "5 200₴",
    combo: 3,
  },
  {
    name: "Андрій C.",
    avgCheck: "590₴",
    upsell: "82%",
    leads: 47,
    salary: "5 200₴",
    combo: 8,
  },
];
